import React, { useEffect, useState, useRef } from 'react';
import {
    getCandidateTask,
    postFresherCandidateTask,
    postExpCandidateTask,
    editFresherCandidateTask,
    editExpCandidateTask,
    editReviewTask,
    sendMail,
} from '../service/RecruiterApi';
//import { Upload } from './utils/Upload';
import { uploadBackend } from '../utils/Upload';
import { getS3 } from '../utils/Download.js';
import moment from 'moment';
import { OnlyNumberSpecialChar, NotificationTrigger } from '../../src/utils/RegHandling';
import { encryptStorage } from '../constant';
//import Loader from './Loader';
import Loader from '../StaticComponent/Loader';
// import Loader from '../../StaticComponent/Loader';

function CandidateTask(props) {
    let employeeId = encryptStorage.getItem('employee_id');
    let prop = props;
    const jobId = prop.jobId;
    const candiId = prop.candidate_id;
    const candidateName = prop.candidate_name;

    let task = {
        candidate_id: '',
        hiring_team_id: '1',
        job_id: '',
        task_name: '',
        attachment_url: '',
        description: '',
        due_date: '',
    };
    let reviewtask = {
        candidate_id: candiId,
        comments: '',
        status: '',
    };

    let [taskMode, setTaskMode] = useState('');
    let [reviewTask, setReviewTask] = useState('');
    let [flag, setFlag] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [editData, setEditData] = useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [taskData, setTaskData] = useState(task);
    let [attachmentLocation, setAttachmentLocation] = useState('');
    const [taskName, setTaskNameError] = useState('');
    const [attachmenturlError, setAttachmentUrlError] = useState('');
    const [dueError, setDueError] = useState('');
    const [description, setDescription] = useState('');
    const [sign, setSign] = useState();
    const [size, setSize] = useState();
    const [path, setpath] = useState();
    const [type, setType] = useState();
    const [reviewtaskData, setReviewTaskData] = useState(reviewtask);
    const [commentsError, setcommentsError] = useState('');
    const [statusError, setstatusError] = useState('');

    const attachment = useRef(null);
    const attachment1 = useRef(null);

    useEffect(() => {
        loadData();
    }, [flag, prop]);

    let loadData = async () => {
        try {
            setIsLoading(false);
            let resp = await getCandidateTask({
                candidate_id: props.candidate_id,
                experience: props.experience,
            });
            setIsLoading(true);

            setGridData(resp.data.data);
        } catch (e) { }
    };

    const fileUpload = async () => {
        let dirName = `${props.candidate_id}-CandidateTask`;
        let file = attachment.current.files[0];
        if (file != undefined) {
            let newFileName = attachment.current.files[0].name;
            let fileData = await uploadBackend(file, newFileName, dirName);
            setAttachmentLocation(fileData);
            return fileData;
        }
        return null;
    };
    let validation = () => {
        let result = true;

        if (taskData.task_name == '') {
            setTaskNameError('Task Name is required');
            result = false;
        } else {
            let checkregex = OnlyNumberSpecialChar(taskData.task_name);
            if (checkregex) {
                setTaskNameError('Valid Task name is required');
            } else {
                setTaskNameError('');
            }
        }

        if (taskData.due_date == '') {
            setDueError('Due Date is required');
            result = false;
        } else {
            setDueError('');
        }

        if (taskData.description == '') {
            setDescription('Description is required');
            result = false;
        } else {
            let checkregex = OnlyNumberSpecialChar(taskData.description);
            if (checkregex) {
                setDescription('Valid Description is required');
            } else {
                setDescription('');
            }
        }

        if (taskData.attachment_url == '') {
            setAttachmentUrlError('Attachment Url is required');
            result = false;
        } else {
            setAttachmentUrlError('');
        }
        if (result == true) {
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
        return result;
    };
    

    let submitTask = async () => {
        if (validation() == true) {
            const attachment = await fileUpload();

            setIsLoading(false);
            let resp;
            if (props.experience == 'Fresher') {
                resp = await postFresherCandidateTask(taskData);
                setIsLoading(true);

                let content = {
                    Subject: `Invite for Design Challenge`,
                    body: `<html lang="en">

                    <head>
                      <meta charset='utf-8'>
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Invite User</title>
                    </head>

                    <body>
                      <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                       <div style="background-color:#ffffff; width: 100%;">
                        <div style="padding: 15px 32px; background-color: #ffffff;">
                         <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                        </div>
                       </div>

                       <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                       <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                        <h3 style=" font-size: 20px; color: #F29B10;">
                        Hi ${props.candidate_name},
                        </h3>
                        <p style=" font-size: 16px; color: #0f0f0f;">
                        As discussed, please complete the design challenge on or before ${taskData.due_date}.<br/><br/>
              Please click in the following link:   <a href="https://hivecandidate.avasoft.com?id=${props.jobId}">https://hivecandidate.avasoft.com?id=${props.jobId} </a>
                      </p>
                      <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                       Yours Truly,
                       </p>
                      <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                       Team Avasoft
                       </p>
                       </div>
                      </div>

                    </div>
                    </body>
                    </html>`,
                    to: [props.email],
                };
                sendMail(content);
            } else if (props.experience == 'Experienced') {
                let data = taskData;
                

                data['candidate_id'] = props.candidate_id;
                data['attachment_url'] = attachment;
                data['job_id'] = props.jobId;
                data['hiring_team_id'] = employeeId;

                resp = await postExpCandidateTask(data);

                setIsLoading(true);
                let content = {
                    Subject: `Invite for Design Challenge`,
                    body: `<html lang="en">

                    <head>
                      <meta charset='utf-8'>
                      <meta name="viewport" content="width=device-width, initial-scale=1.0">
                      <title>Invite User</title>
                    </head>

                    <body>
                      <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
                       <div style="background-color:#ffffff; width: 100%;">
                        <div style="padding: 15px 32px; background-color: #ffffff;">
                         <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
                        </div>
                       </div>

                       <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
                       <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
                        <h3 style=" font-size: 20px; color: #F29B10;">
                        Hi ${props.candidate_name},
                        </h3>
                        <p style=" font-size: 16px; color: #0f0f0f;">
                        As discussed, please complete the design challenge on or before ${taskData.due_date}.
                        Please click in the following link:  <a href="https://hivecandidate.avasoft.com?id=${props.jobId}">https://hivecandidate.avasoft.com?id=${props.jobId} </a>
                      </p>
                      <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
                       Yours Truly,
                       </p>
                      <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
                       Team Avasoft
                       </p>
                       </div>
                      </div>

                    </div>
                    </body>
                    </html>`,
                    to: [props.email],
                };
                sendMail(content);
            }
            let new_task = {
                task_name: '',
                attachmentUrl: '',
                description: '',
                due_date: '',
            };
            setTaskData(new_task);
            setTaskMode('');
            setSign('');
            setFlag(!flag);
            attachment.current.value = '';
            // setSign('');
        }
    };
    
    // let submitTask = async () => {
    //     //debugger;
    //     try {
    //         if (validation() == true) {
    //             const attachment = await fileUpload();

    //             setIsLoading(false);
    //             let resp;
    //             if (props.experience == 'Fresher') {
    //                 resp = await postFresherCandidateTask(taskData);
    //             } else if (props.experience == 'Experienced') {
    //                 let data = {
    //                     ...taskData,
    //                     candidate_id: props.candidate_id,
    //                     attachment_url: attachment,
    //                     job_id: props.jobId,
    //                     hiring_team_id: employeeId
    //                 };
    //                 resp = await postExpCandidateTask(data);
    //             }

    //             setIsLoading(true);
    //             let content = {
    //                 Subject: `Invite for Design Challenge`,
    //                 body: `<html lang="en">
                
    //                                 <head>
    //                                   <meta charset='utf-8'>
    //                                   <meta name="viewport" content="width=device-width, initial-scale=1.0">
    //                                   <title>Invite User</title>
    //                                 </head>
                
    //                                 <body>
    //                                   <div style="width: 100%; border: 0.25px solid #e6e6e6; border-radius: 3px; margin-left: auto; margin-right: auto; max-width: 960px; box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;">
    //                                    <div style="background-color:#ffffff; width: 100%;">
    //                                     <div style="padding: 15px 32px; background-color: #ffffff;">
    //                                      <img src="https://www.avasoft.com/wp-content/uploads/2021/05/logo.png" alt="logo" style="width: 120px;">
    //                                     </div>
    //                                    </div>
                
    //                                    <div style="display: flex; justify-content: center; background-color: #F6F6F6;">
    //                                    <div style="width: 100%; background-color: #ffffff; border-radius: 5px; padding: 10px 25px; margin: 35px 0px; font-family:''; margin-left: auto; margin-right: auto; max-width: 820px;">
    //                                     <h3 style=" font-size: 20px; color: #F29B10;">
    //                                     Hi ${props.candidate_name},
    //                                     </h3>
    //                                     <p style=" font-size: 16px; color: #0f0f0f;">
    //                                     As discussed, please complete the design challenge on or before ${taskData.due_date}.<br/><br/>
    //                           Please click in the following link:   <a href="https://hivenpcandidate.avasoft.com?id=${props.jobId}">https://hivenpcandidate.avasoft.com?id=${props.jobId} </a>
    //                                   </p>
    //                                   <p style="margin-top: 30px; font-size: 16px; color: #0f0f0f;">
    //                                    Yours Truly,
    //                                    </p>
    //                                   <p style=" font-size: 16px; font-weight:bold; color: #F29B10;">
    //                                    Team Avasoft
    //                                    </p>
    //                                    </div>
    //                                   </div>
                
    //                                 </div>
    //                                 </body>
    //                                 </html>`,
    //                 to: [props.email],
    //             };
    //             sendMail(content);
    //             // Send email code...

    //             let new_task = {
    //                 task_name: '',
    //                 attachmentUrl: '',
    //                 description: '',
    //                 due_date: '',
    //             };
    //             setTaskData(new_task);
    //             setTaskMode('');
    //             setSign('');
    //             setFlag(!flag);
    //             attachment.current.value = '';
    //         } else {
    //         }
    //     } catch (error) {
    //         console.error("Error in task submission:", error);
    //         setIsLoading(true);
    //         // Handle error (e.g., show error message to user)
    //     }
    // };


    let submitEditedTask = async () => {
        const attachment = await fileUpload();
        let resp;
        if (props.experience == 'Fresher') {
            resp = await editFresherCandidateTask(editData);
            setIsLoading(true);
        } else if (props.experience == 'Experienced') {
            resp = await editExpCandidateTask(editData);
            setIsLoading(true);
        }
        setEditData([]);
        setTaskMode('');
        setFlag(!flag);
        attachment.current.value = '';
        setSign('');
    };
    const uploadFile = async (e) => {
        try {
            let dirName = `${props.candidate_id}-Task-Upload`;

            setpath(e.target.result);

            if (e.target.files[0].size > 1000000) {
                setAttachmentUrlError('File size should be less than 1MB');
                attachment.current.value = '';
                return false;
            }

            const typeArr = ['pdf', 'txt', 'doc', 'docx', 'msword', 'vnd.openxmlformats-officedocument.wordprocessingml.document'];
            // let type = typeArr.includes(e.target.files[0].type.split('.')[1]);
            let type = typeArr.includes(e.target.files[0].type.split('/')[1]);
            if (type == false) {
                setAttachmentUrlError('The uploaded file should be in PDF or TXT,DOC ,DOCX format');

                attachment.current.value = '';
                setSign('');
                return false;
            } else {
                setAttachmentUrlError('');
                setSign(e.target.files[0].name);
                setSize(e.target.files[0].size);
                setType(e.target.files[0].type);
            }

            const response = await uploadBackend(e.target.files[0], e.target.files[0].name, dirName);

            setTaskData({ ...taskData, attachment_url: response.location });
            setFlag(!flag);
            setEditData({ ...editData, attachment_url: response.location });
        } catch (e) {
            throw e;
        }
    };

    let onValueChange = (e) => {
        setTaskData({ ...taskData, [e.target.id]: e.target.value });
    };

    let onValueReviewChange = (e) => {
        setReviewTaskData({ ...reviewtaskData, [e.target.id]: e.target.value });
    };
    let onEditValueChange = (e) => {
        setEditData({ ...editData, [e.target.id]: e.target.value });
    };

    let editTaskClick = (id) => {
        setEditData(gridData[id]);
        let val = gridData[id].attachment_url?.split('/').pop();

        setSign(val);
    };

    let ReviewTaskClick = (id) => {
        setReviewTask(gridData[id]);
    };

    let cancelClick = () => {
        setTaskMode('');
        attachment.current.value = '';
        setSign('');
    };
    let cancel = () => {
        setSign('');
        attachment.current.value = null;
    };
    let reviewValidation = () => {
        let result = true;

        if (reviewtaskData.comments == '' || reviewtaskData.comments == undefined) {
            setcommentsError('Comments is required');   
            result = false;
        } else {
            let checkregex = OnlyNumberSpecialChar(reviewtaskData.comments);
            if (checkregex) {
                setcommentsError('Comments is required');
                result = false;
            } else {
                setcommentsError('');
            }
        }

        if (reviewtaskData.status == '' || reviewtaskData.status == undefined) {
            setstatusError('Status is required');
            result = false;
        } else {
            setstatusError('');
        }
        return result;
    };
    const sendReviewTask = async () => {
        if (reviewValidation() == true) {
            let resp = await editReviewTask(reviewtaskData);
            setTaskMode('');
            let reviewtask = {
                candidate_id: candiId,
                comments: '',
                status: '',
            };
            setReviewTaskData(reviewTask);
        }
    };

    let bindTasks = () => {
        try {
            return gridData.map((obj, index) => {
                let arr = obj.attachment_url.split('/');
                let fileName = arr[arr.length - 1];
                return (
                    <tr key={index} className="hive-table-data regular-text align-middle">
                        <td>
                            {' '}
                            <a
                                className="cursor-pointer"
                                onClick={() => {
                                    setTaskMode('Review');
                                    ReviewTaskClick(index);
                                }}
                            >
                                {obj.task_name}
                            </a>
                        </td>
                        <td>created</td>
                        <td>{moment(obj.due_date).format('L')}</td>
                        <td>
                            <a className="cursor-pointer" href="#" target="_blank"  style={{cursor:"pointer"}} onClick={async () => {

window.open(await getS3(obj?.attachment_url, "1"), "_blank");

}} >
                                {fileName}
                            </a>
                        </td>
                        <td>
                            <a
                                className="cursor-pointer"
                                onClick={() => {
                                    setTaskMode('Edit');
                                    editTaskClick(index);
                                }}
                            >
                                <img src="/Images/Edit.svg" alt="Select-icon" className="me-1" />
                            </a>
                        </td>
                    </tr>
                );
            });
        } catch (e) { }
    };

    let minDate = moment(new Date()).format('L');
    minDate = minDate.split('/')[2] + '-' + minDate.split('/')[0] + '-' + minDate.split('/')[1];
    let editDataDate = moment(editData.due_date).format('L');
    editDataDate = editDataDate.split('/')[2] + '-' + editDataDate.split('/')[0] + '-' + editDataDate.split('/')[1];
    editData.due_date = editDataDate;

    return (
        <div>
            <div hidden={taskMode == '' ? false : true}>
                <div hidden={gridData?.length == 0 ? false : true} className="row justify-content-center">
                    <img
                        src="/Images/nodatafound.png"
                        alt="nodatafound"
                        className="nofeedbackimg-sty"
                        style={{ height: '500px', width: '750px' }}
                    ></img>
                    <h2 className="semibold-text font-25 text-center margin-negative">No Tasks Added!</h2>
                    <button
                        className="btn button-wide hive-btn-outline small-button font-14"
                        onClick={() => {
                            setTaskMode('New');
                        }}
                    >
                        Add Task
                    </button>
                </div>
            </div>
            <div hidden={taskMode == '' && gridData?.length != 0 ? false : true} className="mt-4 mb-4 text-end">
                <button
                    className="btn hive-btn-outline small-button font-14"
                    onClick={() => {
                        setTaskMode('New');
                    }}
                >
                    Add Task
                </button>
            </div>

            <div
                hidden={gridData?.length == 0 || taskMode == 'New' || taskMode == 'Edit' || taskMode == 'Review' ? true : false}
                className="table-responsive rounded-3"
            >
                <table className="table bg-white hive-grid table-borderless ">
                    <thead className="hive-table-head ">
                        <tr>
                            <th className="bold-text font-12 hive-header-th">Name</th>
                            <th className="bold-text font-12 hive-header-th">Activity</th>
                            <th className="bold-text font-12 hive-header-th">Date</th>
                            <th className="bold-text font-12 hive-header-th">Attachment</th>
                            <th className="bold-text font-12 hive-header-th">Action</th>
                        </tr>
                    </thead>
                    <tbody>{bindTasks()}</tbody>
                </table>
            </div>

            <div hidden={taskMode == 'New' ? false : true}>
                <h1 className="mt-3 font-16 bold-text">New Task</h1>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex my-4">
                        <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="profile-image" />
                        <div className="ms-2 ps-2">
                            <label href="#" className="mb-0 font-16 regular-text dropdown-sublabel-color">
                                Assigned
                            </label>
                            <p className="mb-0 font-16 regular-text profile-label-color">{candidateName}</p>
                        </div>
                    </div>
                </div>
                <div className="w-100 float-start mb-4">
                    <label className="hive-form-label form-label">
                        Task Name <span className="hive-form-mandatory">*</span>
                    </label>
                    <input
                        className="w-100 custom-textfield form-control regular-text font-12"
                        id="task_name"
                        value={taskData.task_name}
                        onChange={onValueChange}
                        placeholder="Enter Task Name"
                    ></input>
                    <span style={{ color: 'red' }}>{taskName}</span>
                </div>

                <div className="row mt-4">
                    <div className="col-md-3">
                        <div style={{ display: 'flex' }}>
                            <h1 className="hive-form-label form-label">
                                Attachment<span className="hive-form-mandatory">*</span>
                                <span>
                                    <img src="/Images/info-icon.svg" alt="info-icon" className="ms-2" title="Upload less than 1 MB" />
                                </span>
                            </h1>
                        </div>
                        <label htmlFor="fileAttachment" className="custom-file-upload-styles">
                            <img className="me-2" src="/Images/profile-upload-icon.svg" alt="Upload Icon" />
                            Upload
                        </label>
                        <input id="fileAttachment" className="custom-file-upload-btn" type="file" ref={attachment} onChange={uploadFile} />
                        <div>
                            {sign}{' '}
                            {sign !== '' && sign !== undefined && sign !== null ? (
                                <img
                                    src="/Images/profile-certificate-cancel.svg"
                                    alt=""
                                    onClick={() => {
                                        cancel();
                                    }}
                                />
                            ) : null}
                        </div>
                        <div>
                            <span style={{ color: 'red' }}>{attachmenturlError}</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mt-4 mb-3">
                    <label className="hive-form-label form-label" htmlFor="task-comments">
                        Description<span className="hive-form-mandatory">*</span>
                    </label>
                    <textarea
                        className="w-100 job-posting-commentbox mt-2 form-control hive-form-control "
                        id="description"
                        value={taskData.description}
                        onChange={onValueChange}
                        placeholder="Enter Description"
                    />
                    <span style={{ color: 'red' }}>{description}</span>
                </div>
                <div className="col-md-3 mb-3">
                    <label className="hive-form-label form-label" htmlFor="task-comments">
                        Due Date <span className="hive-form-mandatory">*</span>
                    </label>
                    <input
                        type="date"
                        min={minDate}
                        className="form-control hive-form-control custom-textfield regular-text"
                        id="due_date"
                        value={taskData.due_date}
                        onChange={onValueChange}
                    ></input>
                    <span style={{ color: 'red' }}>{dueError}</span>
                </div>
                <div className="col-md-12 d-flex justify-content-end mb-4 mt-5">
                    <button
                        className="btn hive-btn-secondary me-2"
                        onClick={() => {
                            cancelClick();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn hive-btn-primary"
                        onClick={() => {
                            setIsLoading(false);
                            submitTask();
                        }}
                    >
                        Send
                    </button>
                </div>
                <Loader isLoading={isLoading} />
            </div>

            {/**EDIT TASK**/}
            <div hidden={taskMode == 'Edit' ? false : true}>
                <h1 className="mt-3 font-16 bold-text">Edit Task</h1>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex my-4">
                        <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="profile-image" />
                        <div className="ms-2 ps-2">
                            <label href="#" className="mb-0 font-16 regular-text dropdown-sublabel-color">
                                Assigned
                            </label>
                            <p className="mb-0 font-16 regular-text profile-label-color">{candidateName}</p>
                        </div>
                    </div>
                </div>
                <div className="w-100 float-start mb-4">
                    <label className="hive-form-label form-label">
                        Task Name <span className="hive-form-mandatory">*</span>
                    </label>
                    <input
                        className="w-100 custom-textfield form-control regular-text font-12"
                        id="task_name"
                        value={editData.task_name}
                        onChange={onEditValueChange}
                        placeholder="Enter task name"
                    ></input>
                </div>

                <div className="row mt-4">
                    <div className="col-md-3">
                        <h1 className="hive-form-label form-label">
                            Attachment <span className="hive-form-mandatory">*</span>
                            <span>
                                <img src="/Images/info-icon.svg" alt="info-icon" className="ms-2" title="Upload less than 1 MB" />
                            </span>
                        </h1>
                        <label htmlFor="voterid-upload" className="custom-file-upload-styles">
                            <img className="me-2" src="/Images/profile-upload-icon.svg" alt="Upload Icon" />
                            Upload
                        </label>
                        <input
                            id="voterid-upload"
                            className="custom-file-upload-btn"
                            type="file"
                            ref={attachment1}
                            onChange={uploadFile}
                        />{' '}
                        <div>
                            {sign}{' '}
                            {sign !== '' && sign !== undefined && sign !== null ? (
                                <img
                                    src="/Images/profile-certificate-cancel.svg"
                                    alt=""
                                    onClick={() => {
                                        cancel();
                                    }}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="col-md-12 mt-4 mb-3">
                    <label className="hive-form-label form-label" htmlFor="task-comments">
                        Description<span className="hive-form-mandatory">*</span>
                    </label>
                    <textarea
                        className="w-100 job-posting-commentbox mt-2 form-control hive-form-control "
                        id="description"
                        value={editData.description}
                        onChange={onEditValueChange}
                        placeholder="Enter Description"
                    />
                </div>
                <div className="col-md-3 mb-3">
                    <label className="hive-form-label form-label" htmlFor="task-comments">
                        Due Date <span className="hive-form-mandatory">*</span>
                    </label>
                    <input
                        type="date"
                        min={minDate}
                        className="form-control hive-form-control custom-textfield regular-text"
                        id="due_date"
                        value={editData.due_date}
                        onChange={onEditValueChange}
                    ></input>
                </div>
                <div className="col-md-12 d-flex justify-content-end mb-4 mt-5">
                    <button
                        className="btn hive-btn-secondary me-2"
                        onClick={() => {
                            cancelClick();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn hive-btn-primary"
                        onClick={() => {
                            setIsLoading(false);
                            submitEditedTask();
                        }}
                    >
                        Send
                    </button>
                </div>
            </div>

            <div hidden={taskMode == 'Review' ? false : true}>
                <h1 className="mt-3 font-16 semibold-text">Review Task</h1>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex my-4">
                        <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="profile-image" />
                        <div className="ms-2 ps-2">
                            <label href="#" className="mb-0 font-16 regular-text dropdown-sublabel-color">
                                Created by
                            </label>
                            <p className="mb-0 font-16 regular-text profile-label-color">{candidateName}</p>
                        </div>
                    </div>
                    <div>
                        <button
                            className="custom-task-red-btn font-14 regular-text me-2"
                            onClick={() => {
                                setReviewTaskData({ ...reviewtaskData, status: 'rejected' });
                            }}
                        >
                            <span>
                                <img src="/Images/Cross-task.svg" className="btn-size" />
                            </span>
                            Rejected
                        </button>
                        <button
                            className="custom-task-green-btn font-14 regular-text"
                            onClick={() => {
                                setReviewTaskData({ ...reviewtaskData, status: 'selected' });
                            }}
                        >
                            <span>
                                <img src="/Images/tick-task.svg" className="btn-size" />
                            </span>
                            Selected
                        </button>
                    </div>
                    <span style={{ color: 'red' }}>{statusError}</span>
                </div>
                <div className="w-100 float-start mb-3">
                    <label className="bold-text font-15">Task Name</label>
                    <p className="font-14 regular-text mt-1">{reviewTask.task_name}</p>
                </div>
                <div className="w-100 float-start mb-3">
                    <label className="bold-text font-15">Description</label>
                    <p className="font-14 regular-text mt-1">{reviewTask.description}</p>
                </div>
                <div className="row mt-4">
                    <div className="col-md-3">
                        <h1 className="bold-text font-15 mb-0">Attachment</h1>
                        <a
                            className="font-14 regular-text mt-1 color-purple text-decoration-none"
                            href={reviewTask.attachment_url}
                            target="_blank"
                        >
                            {reviewTask?.attachment_url?.split('/').pop()}
                        </a>
                    </div>
                    <div className="col-md-3">
                        <h1 className="bold-text font-15 mb-0">Submitted on</h1>
                        <p className="font-14 regular-text mt-1">{moment(reviewTask.created_at).format('L')}</p>
                    </div>
                </div>
                <div className="col-md-12 mt-4">
                    <label className="font-12 semibold-text" htmlFor="task-comments">
                        Comments<span className="hive-form-mandatory">*</span>
                    </label>
                    <textarea
                        placeholder="Enter Comments"
                        className="w-100 custom-task-comments form-control regular-text font-12 mt-2"
                        id="comments"
                        value={reviewtaskData.comments}
                        onChange={onValueReviewChange}
                    />
                    <span style={{ color: 'red' }}>{commentsError}</span>
                </div>
                <div className="col-md-12 d-flex justify-content-end mb-4 mt-5">
                    <button
                        className="btn hive-btn-secondary me-2"
                        onClick={() => {
                            cancelClick();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn hive-btn-primary"
                        onClick={() => {
                            sendReviewTask();
                        }}
                    >
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CandidateTask;
